import {schoolChangeActionTypes as types} from '../constants';
import initialState from './initialState';

function schoolChangeStatus(state = initialState, action) {
  switch (action.type) {
    case types.INITIALIZE_CHANGE_SCHOOL_REQUEST:
      return {...state, isError: false, isLoading: true, isSuccess: false};
    case types.SCHOOL_CHANGE_LOAD_SUCCESS:
      return {...state, isError: false, isLoading: false, isSuccess: true};
    case types.SCHOOL_CHANGE_LOAD_FAILURE:
      return {...state, isError: true, isLoading: false, isSuccess: false};
    default:
      return state;
  }
}

export default schoolChangeStatus;
